var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "app-toast",
    {
      staticClass: "resend-confirmation-toast",
      attrs: { message: _vm.message }
    },
    [
      _c("div", {
        staticClass: "toast-body",
        domProps: {
          innerHTML: _vm._s(
            _vm.$t("user.confirmation.resent", { mail: _vm.message.mail })
          )
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }